const React = require("react");
function IconQuote(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.2729 8.44787C17.606 7.78293 17.1225 7 16.3788 7h-.7686c-.3785 0-.7246.21371-.8941.55213l-.704 1.40545c-.6728 1.34312-1.0231 2.82462-1.0231 4.32672v.7102c0 1.6599 1.3483 3.0055 3.0082 3.0055C17.6541 17 19 15.6569 19 14s-1.3487-3-3.0055-3zm-7.98898 0C9.61701 7.78293 9.13353 7 8.38982 7H7.6212c-.37851 0-.72457.21371-.8941.55213l-.70401 1.40545C5.35031 10.3007 5 11.7822 5 13.2843v.7102C5 15.6544 6.34837 17 8.00827 17c1.65686 0 3.00273-1.3431 3.00273-3s-1.34863-3-3.00549-3z",
    clipRule: "evenodd"
  }));
}
module.exports = IconQuote;